import { render, staticRenderFns } from "./MapCom.vue?vue&type=template&id=4546b7f8&"
import script from "./MapCom.vue?vue&type=script&lang=ts&"
export * from "./MapCom.vue?vue&type=script&lang=ts&"
import style0 from "./MapCom.vue?vue&type=style&index=0&id=4546b7f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports